import React from 'react';
import PropTypes from 'prop-types';
import { YoutubeVideo, H2, Container, Image } from 'components/atoms';
import { ReadMoreButton, PSPModuleWrapper } from 'components/molecules';
import { PSPMarkdownModule } from 'components/psp/PSPMarkdown';
import ContentIcon from 'assets/images/psp/search-property.svg';
import './PSPVideo.scss';

export default function PSPVideo({
	src,
	content,
	image,
	theme = 'dark',
	imageSrc,
	className,
}) {
	let color = theme === 'light' ? 'black' : 'white';

	// Check if content exists and has data
	const hasContent = content && (content.title || content.description);

	return (
		<PSPModuleWrapper
			className={`new-psp-video-container theme-${theme} ${
				!hasContent ? 'video-only' : ''
			} ${className || ''}`}
		>
			<Container className="new-psp-video-content">
				{hasContent && (
					<div className="new-psp-video-content-text">
						{content && (
							<Image
								src={image || ContentIcon}
								titleIcon
								alt={`${content.title} Icon`}
							/>
						)}
						{content.title && (
							<H2
								size="large"
								color={color}
								family={
									content.pageType === 'SGP'
										? 'rounded'
										: 'standard'
								}
							>
								{content.title}
							</H2>
						)}
						{content.description && (
							<>
								<div className="desktop-header-text">
									<PSPMarkdownModule
										content={content.description}
										additionalProps={{
											paragraph: { color },
											anchor: { color },
											ul: { style: { color } },
										}}
									/>
								</div>

								<div className="mobile-read-more">
									<ReadMoreButton>
										<PSPMarkdownModule
											content={content.description}
											additionalProps={{
												paragraph: { color },
												anchor: { color },
											}}
										/>
									</ReadMoreButton>
								</div>
							</>
						)}
					</div>
				)}

				<div
					className={`new-psp-video-content-player ${
						!hasContent ? 'full-width' : ''
					}`}
				>
					{imageSrc ? (
						<Image
							src={imageSrc}
							alt={content.title}
						/>
					) : (
						<YoutubeVideo src={src} />
					)}
				</div>
			</Container>
		</PSPModuleWrapper>
	);
}

PSPVideo.propTypes = {
	src: PropTypes.string,
	content: PropTypes.object.isRequired,
	image: PropTypes.string,
	theme: PropTypes.oneOf(['light', 'dark']),
	imageSrc: PropTypes.string,
	className: PropTypes.string,
};
